var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8893 16.5964C31.8893 7.79833 24.8013 0.666992 16.056 0.666992C7.31071 0.666992 0.222656 7.79833 0.222656 16.5964C0.222656 24.5489 6.01132 31.1388 13.5818 32.3337V21.2018H9.56221V16.5953H13.5818V13.0867C13.5818 9.09455 15.9452 6.88844 19.5625 6.88844C21.2937 6.88844 23.1071 7.19983 23.1071 7.19983V11.1202H21.1089C19.1424 11.1202 18.5302 12.3488 18.5302 13.6092V16.5964H22.9213L22.2194 21.2007H18.5302V32.3337C26.1007 31.1388 31.8893 24.5489 31.8893 16.5964Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a0b14e59506af60904366742af909547.svg";
export { ForwardRef as ReactComponent };